import { useThree } from '@react-three/fiber';
import { folder, useControls } from 'leva';
import { useLayoutEffect, useRef } from 'react';
import * as THREE from 'three';

export const IslandEnvironment = () => {
  const spotlightRef = useRef<THREE.SpotLight>(null!);

  const controls = useControls(
    'dirLight',
    {
      positionX: {
        value: 0,
        min: -50,
        max: 50,
        step: 1,
      },
      positionY: {
        value: 14,
        min: -30,
        max: 30,
        step: 1,
      },
      positionZ: {
        value: 0,
        min: -30,
        max: 30,
        step: 1,
      },
      rotationX: {
        value: -0,
        min: -Math.PI,
        max: Math.PI,
        step: 0.001,
      },
      rotationY: {
        value: 0,
        min: -Math.PI,
        max: Math.PI,
        step: 0.001,
      },
      rotationZ: {
        value: -0,
        min: -Math.PI,
        max: Math.PI,
        step: 0.001,
      },
      shadow: folder({
        shadowTop: {
          value: 50,
          min: -50,
          max: 50,
          step: 0.1,
        },
        shadowBottom: {
          value: -50,
          min: -50,
          max: 50,
          step: 0.1,
        },
        shadowRight: {
          value: 50,
          min: -50,
          max: 50,
          step: 0.1,
        },
        shadowLeft: {
          value: -50,
          min: -50,
          max: 50,
          step: 0.1,
        },
        bias: {
          value: 0.0005,
          max: 0.5,
          min: -0.5,
          step: 0.0001,
        },
        normalBias: {
          value: 0.06,
          max: 0.5,
          min: -0.5,
          step: 0.0001,
        },
      }),
      intensity: {
        value: 0.68,
        min: 0,
        max: 10,
        step: 0.01,
      },
      dirLightColor: {
        value: '#b0b0b7',
      },
      bgColor: {
        value: '#0f0f2e',
      },
      fogColor: {
        value: '#0f0f2e',
      },
      fogDensity: {
        min: 0,
        max: 0.05,
        value: 0.003,
      },
    },
    { collapsed: false }
  );
  const scene = useThree((state) => state.scene);
  useLayoutEffect(() => {
    // dirLightRef.current = dirLight;
    // dirLightRef.current.castShadow = true;
    // dirLightRef.current.shadow.camera.near = 0.1;
    // dirLightRef.current.shadow.camera.far = 30;
    // dirLightRef.current.shadow.camera.top = 16;
    // dirLightRef.current.shadow.camera.right = 28;
    // dirLightRef.current.shadow.camera.bottom = -28;
    // dirLightRef.current.shadow.camera.left = -28;
    // dirLightRef.current.shadow.normalBias = 0.02;
    // dirLightRef.current.shadow.bias = 0.01;
    // scene.add(dirLight);
    // scene.add(dirLight.target);
    // const dirLightHelper = new THREE.DirectionalLightHelper(dirLight, 1);
    // helperRef.current = dirLightHelper;
    // scene.add(dirLightHelper);
    // const pointLight = new THREE.PointLight();
    // const pointlightHelper = new THREE.PointLightHelper(pointLight, 1);
    // pointLight.castShadow = true;
    // helperRef.current = pointlightHelper;
    // pointLightRef.current = pointLight;
    // scene.add(pointLight);
    // scene.add(pointlightHelper);
    // scene.fog = new THREE.FogExp2(controls.fogColor, controls.fogDensity);
    // dirLightRef.current.shadow.camera.top = controls.shadowTop;
    // dirLightRef.current.shadow.ne
  }, [controls, scene]);

  return (
    <>
      <color args={[controls.bgColor]} attach={'background'} />
      {/* <fogExp2
        attach={'fog'}
        args={[controls.fogColor, controls.fogDensity]}
        density={controls.fogDensity}
        color={controls.fogColor}
      /> */}
      <fog attach='fog' args={[controls.fogColor, 15, 60]} />
      {/* <ambientLight intensity={0.1} color={'#acacc1'} />
      <directionalLight
        ref={dirLightRef}
        position={[controls.positionX, controls.positionY, controls.positionZ]}
        rotation={[controls.rotationX, controls.rotationY, controls.rotationZ]}
        castShadow={true}
        intensity={controls.intensity}
        shadow-mapSize={[2048, 2048]}
        shadow-camera-near={0.1}
        shadow-camera-far={30}
        shadow-camera-top={controls.shadowTop}
        shadow-camera-bottom={controls.shadowBottom}
        shadow-camera-right={controls.shadowRight}
        shadow-camera-left={controls.shadowLeft}
        shadow-normalBias={controls.normalBias}
        shadow-bias={controls.normalBias}
        shadow-needsUpdate={true}
      />

      {dirLightRef.current && (
        <directionalLightHelper
          args={[dirLightRef.current, 2, 0xffffff]}
          update={() => true}
        />
      )} */}
      <ambientLight intensity={0.5} color='#b8c5d6' />
      {/* <directionalLight
        position={[10, 20, 5]}
        intensity={0.3}
        color='#b8c5d6'
        castShadow={true}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={0.1}
        shadow-camera-far={50}
        shadow-camera-top={20}
        shadow-camera-bottom={-20}
        shadow-camera-right={20}
        shadow-camera-left={-20}
        shadow-normalBias={0.05}
        shadow-bias={-0.001}
      /> */}
      {/* <directionalLight
        position={[2.5, 8, 5]}
        intensity={0.5}
        color={'#b8c5d6'}
      > */}
      {/* <orthographicCamera
          attach='shadow-camera'
          args={[-10, 10, -10, 10, 0.1, 50]}
        /> */}
      {/* </directionalLight> */}
      <spotLight
        ref={spotlightRef.current}
        position={[0, 25, 0]}
        target-position={[0, 0, 0]}
        intensity={1.7}
        color='#ffffff'
        angle={Math.PI / 6}
        penumbra={0.3}
        distance={50}
        decay={0.01}
        castShadow={true}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={50}
        shadow-bias={-0.0001}
      />
      {spotlightRef.current && (
        <spotLightHelper args={[spotlightRef.current, '#ff0000']} />
      )}
    </>
  );
};
